import React, { useRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormElement, Req, SubmitButton } from "../blocks/forms";
import { Column, Grid } from "../blocks";
import ReCAPTCHA from "react-google-recaptcha";
import english from "../../../content/translations/en-CA/contact.json";
import PrivacyPolicy from "./PrivacyPolicy";

const NewContactUsForm = ({ returnURL }) => {
  const RecaptchaKey = "6LdRTiAdAAAAAJKnd7u1oETrHAP417MWwQZsBjkJ";
  const URL =
    "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D80000000LKWA";
  const { register, handleSubmit, formState } = useForm({
    mode: "onChange",
  });
  const { errors } = formState;

  const isNotEmpty = value => {
    return value.trim() !== "" || null || undefined;
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const submitForm = () => {
    const recaptchaResponse = window.grecaptcha.getResponse();
    console.log(recaptchaResponse);
    if (!recaptchaResponse) {
      alert("Form not submitted.\nCaptcha must be completed.");
      return;
    }

    const captchaSettings = document.querySelector(
      'input[name="captcha_settings"]'
    );
    const timestamp = new Date().getTime();
    const settings = JSON.parse(captchaSettings.value);
    settings.ts = timestamp;
    captchaSettings.value = JSON.stringify(settings);

    document.getElementById("demo-form").submit();
  };

  function timestamp() {
    var response = document.getElementById("g-recaptcha-response");
    var settings = document.getElementsByName("captcha_settings");
    if (!response || !settings) {
      clearInterval(myInterval);
      return;
    }
    if (response == null || response.value.trim() == "") {
      var elems = JSON.parse(settings[0].value);
      elems["ts"] = JSON.stringify(new Date().getTime());
      settings[0].value = JSON.stringify(elems);
    }
  }
  const myInterval = setInterval(timestamp, 500);

  const message = "00NOG000001GeKH";

  return (
    <form
      id="demo-form"
      action={URL}
      method="POST"
      onSubmit={handleSubmit(submitForm)}
      style={{ maxWidth: "1280px", margin: "20px auto", fontWeight: "700" }}
      noValidate
    >
      <fieldset style={{ border: "none" }}>
        <input
          type="hidden"
          name="captcha_settings"
          value='{"keyname":"Plusgrade_Request_Demo","fallback":"true","orgId":"00D80000000LKWA","ts":""}'
        />
        <input type="hidden" name="oid" value="00D80000000LKWA" />
        <input type="hidden" name="retURL" value={`${returnURL}?submitted`} />

        <Grid columns={2} form>
          <Column>
            <FormElement>
              <label htmlFor="first_name">
                {english.contact_form.fields.firstName}
                <Req />
              </label>
              <input
                id="first_name"
                maxLength="40"
                name="first_name"
                placeholder="First name"
                type="text"
                {...register("first_name", {
                  required: english.contact_form.validation.fname,
                  pattern: {
                    value: /^[a-zA-Z\s\-']+$/,
                    message: "First name is not valid.",
                  },
                  validate: firstName =>
                    isNotEmpty(firstName) ||
                    english.contact_form.validation.fname,
                })}
              />
              <small>{errors.first_name?.message}</small>
            </FormElement>
          </Column>
          <Column>
            <FormElement>
              <label htmlFor="last_name">
                {english.contact_form.fields.lastName}
                <Req />
              </label>
              <input
                id="last_name"
                className="last_name"
                maxLength="80"
                name="last_name"
                placeholder="Last name"
                type="text"
                {...register("last_name", {
                  required: english.contact_form.validation.lname,
                  pattern: {
                    value: /^[a-zA-Z\s\-']+$/,
                    message: "Last name is not valid.",
                  },
                  validate: lastName =>
                    isNotEmpty(lastName) ||
                    english.contact_form.validation.lname,
                })}
              />
              <small>{errors.last_name?.message}</small>
            </FormElement>
          </Column>
        </Grid>
        <Grid columns={2} form>
          <Column>
            <FormElement>
              <label htmlFor={"email"}>
                {english.contact_form.fields.email}
                <Req />
              </label>
              <input
                id="email"
                className="email"
                maxLength="80"
                name="email"
                placeholder="Business Email"
                size="20"
                type="email"
                {...register("email", {
                  required: english.contact_form.validation.email_required,
                  pattern: {
                    value: /^([a-z.%+-]+)@([a-z-]+\.)+([a-z]{2,})$/,
                    message: english.contact_form.validation.email_invalid,
                  },
                  validate: email => {
                    let regex = /gmail|yahoo|hotmail|icloud/;
                    return (
                      !regex.test(email) ||
                      "Please enter your business email address. Personal email addresses such as Gmail, Hotmail and Yahoo are not accepted."
                    );
                  },
                })}
              />
              <small>{errors.email?.message}</small>
            </FormElement>
          </Column>
          <Column>
            <FormElement>
              <label htmlFor="company">
                {english.contact_form.fields.company}
                <Req />
              </label>
              <input
                id="company"
                className="company"
                maxLength="40"
                name="company"
                placeholder="Company"
                size="20"
                type="text"
                {...register("company", {
                  required: english.contact_form.validation.company,
                  pattern: {
                    value: /^[a-zA-Z0-9]+/,
                    message: "Company is not valid.",
                  },
                  validate: company =>
                    isNotEmpty(company) ||
                    english.contact_form.validation.company,
                })}
              />
              <small>{errors.company?.message}</small>
            </FormElement>
          </Column>
        </Grid>

        <FormElement single>
          <label htmlFor={"phone"}>{english.contact_form.fields.phone}</label>
          <input
            id="phone"
            className="phone"
            maxLength="40"
            name="phone"
            placeholder="Phone Number"
            size="20"
            type="tel"
            {...register("phone", {
              pattern: {
                value: /^(?=.*[0-9])[- +()0-9]+$/,
                message: english.contact_form.validation.phone,
              },
            })}
          />
          <small>{errors.phone?.message}</small>
        </FormElement>

        <FormElement single>
          <label htmlFor={"00NOG000001GeKH"}>
            {english.contact_form.fields.desc}
          </label>
          <textarea
            style={{ height: 150 }}
            id="00NOG000001GeKH"
            name="00NOG000001GeKH"
            placeholder="Tell us more about your loyalty program revenue goals."
            {...register("00NOG000001GeKH", {
              pattern: {
                value: /^[\w\s\d,.!?'"():;-]+/,
                message: "Format is not valid.",
              },
            })}
          ></textarea>
          <small>{errors[message]?.message}</small>
        </FormElement>

        <FormElement single>
          <div class="g-recaptcha" data-sitekey={RecaptchaKey}></div>
        </FormElement>

        <FormElement single>
          <PrivacyPolicy
            policy={
              "By clicking “Submit”, you agree to send your email address to Points so they may contact you about the above request. Points.com Inc. agrees to use your info in accordance with their "
            }
            link={"https://www.points.com/legal/privacy/"}
            clickableText={"privacy policy."}
          ></PrivacyPolicy>
        </FormElement>

        <SubmitButton type={"submit"} name="btnSubmit" value={"Submit"} />
      </fieldset>
    </form>
  );
};

export default NewContactUsForm;
